<template>
  <div>
    <!--   Десктоп модалка задачи  -->
    <div class="modal" style="align-items: flex-start" v-if="showModal">
      <div class="modal__back" @click="showModal = false"></div>
      <div class="modal__body modal__body--task-do">
        <div class="modal__attention">
          <div class="modal__attention__header">

            <Close class="modal__close" @click="showModal = false"/>

            <p class="modal__attention__title">
              {{ selectedRow.name || selectedRow.fullname }}
            </p>
          </div>
          <div
            class="modal__attention__description"
            v-if="content"
          >
            <label>Содержание</label>
            <p>
              {{ content }}
            </p>
          </div>

          <div v-if="history.length" class="modal__attention__table">
              <label>Визы</label>
              <vue-good-table
                :columns="columnsAgreement"
                :rows="history"
                compactMode
              >
                <template slot="table-row" slot-scope="props">
                  <template v-if="props.column.field === 'autor'"><div>{{ props.row.autor }}</div></template>
                  <template v-if="props.column.field === 'result' && props.row.result === 'Согласовано'" class="tag tag--green tag--task">{{ props.row.result }}</template>
                  <template v-else-if="props.column.field === 'result' && props.row.result === 'СогласованоСЗамечаниями'" class="tag tag--yellow tag--task">Согласовано с замечаниями</template>
                  <template v-else-if="props.column.field === 'result' && props.row.result === 'НеСогласовано'" class="tag tag--red tag--task"><div>Не согласовано</div></template>
                  <template v-else-if="props.column.field === 'result' && props.row.result === ''"><div>-</div></template>
                  <template v-if="props.column.field === 'comment'"><div>{{ props.row.comment || '-' }}</div></template>
                </template>
              </vue-good-table>
            </div>

          <div
            v-if="selectedRow.history"
            class="modal__attention__block"
          >
              <label @click="openHistory = !openHistory">
                <span>История</span>
                <div class="history__icon">
                  <svg v-if="!openHistory" width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                    <path d="M12 5V19" stroke="#7a7a7a" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
                    <path d="M5 12H19" stroke="#7a7a7a" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
                  </svg>
                  <MinusIco v-else/>
                </div>
              </label>

              <span :style="{ 'display': openHistory ? 'block' : 'none' }">
                {{selectedRow.history}}
              </span>
            </div>

          <div
            v-if="docs.length"
            class="modal__attention__block"
          >
            <label @click="openDocuments = !openDocuments">
              <span>Документы</span>
              <div class="history__icon">
                <svg v-if="!openDocuments" width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                  <path d="M12 5V19" stroke="#7a7a7a" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
                  <path d="M5 12H19" stroke="#7a7a7a" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
                </svg>
                <MinusIco v-else/>
              </div>
            </label>
            <ul :style="{ 'display': openDocuments ? 'block' : 'none' }">
              <li
                v-for="(item, index) in docs"
                :key="index"
              >
                <a
                  class="modal__attention__files"
                  :href="`${BASE_URL}/file?id=${item.id}`"
                  download
                >
                  <Documentation />
                  <span>
                    {{`${item.name}.${item.ext}`}}
                  </span>
                </a>
              </li>
            </ul>
          </div>

          <div v-if="selectedRow.type_doc === 'Реестр платежей'">
            <span class="modal__attention__title">Реестр платежей</span>
            <ul>
              <li>
                <a class="modal__attention__files" :href="`${BASE_URL}/download?id=${selectedRow.id_doc}&type=registry`" target="_blank">Скачать</a>
              </li>
            </ul>
          </div>
          <div
            v-if="
              selectedRow.path_dot==='Согласовать' ||
              selectedRow.path_dot==='Исполнить' || 'Проверить исполнение'
            "
            class="modal__comment"
          >
            <label>Комментарий</label>
            <textarea v-model="message"></textarea>
          </div>
          <div
            v-if="selectedRow.memo.type"
            class="modal__attention__actions"
          >
            <router-link
              class="btn"
              v-if="selectedRow.memo.type === 'Лизинговая сделка'"
              :to="{
                name: 'trade',
                params: {
                  id: selectedRow.memo.link
                }
              }"
            >
              Перейти в сделку
            </router-link>
            <router-link
              class="btn"
              v-if="selectedRow.memo.type === 'Договор лизинга'"
              :to="{
                name: 'contract',
                params: {
                  id: selectedRow.memo.link
                }
              }"
            >
              Перейти в договор
            </router-link>
          </div>
          <mq-layout :mq="['xs', 'md', 'lg', 'xlg', 'xl']" >
            <div class="modal__attention__btns" style="justify-content:center;">
              <button
                v-if="selectedRow.path_dot==='Исполнить'"
                class="modal__attention__btn modal__attention__btn--orange"
                @click="updateTask('done', 'Исполнено')"
              >
                Исполнено
              </button>

              <!-- <button v-if="selectedRow.path_dot==='Утвердить'" class="modal__attention__btn modal__attention__btn--green" @click="makeSign">Подписать</button>
              <button v-if="selectedRow.path_dot==='Утвердить'" class="modal__attention__btn modal__attention__btn--orange" @click="updateTask('reject')">Отклонить</button> -->

              <button
                v-if="selectedRow.path_dot==='Согласовать'"
                :disabled='noComment'
                class="modal__attention__btn modal__attention__btn--green"
                @click="updateTask('approve', 'Согласовано', selectedRow.id_doc)"
              >
                Согласовано
              </button>
              <button
                v-if="selectedRow.path_dot==='Согласовать'"
                :disabled='noComment'
                class="modal__attention__btn modal__attention__btn--orange"
                @click="updateTask('reject', 'Не согласовано')"
              >
                Не согласовано
              </button>
              <button
                v-if="selectedRow.path_dot==='Проверить исполнение'"
                :disabled='noComment'
                class="modal__attention__btn modal__attention__btn--green"
                @click="updateTask('done', 'Проверено')"
              >
                Проверено
              </button>
              <button
                v-if="selectedRow.path_dot==='Проверить исполнение'"
                :disabled='noComment'
                class="modal__attention__btn modal__attention__btn--orange"
                @click="updateTask('revision', 'Вернуть на доработку')"
              >
                Вернуть на доработку
              </button>
              <button
                v-if="selectedRow.path_dot.includes('Ознакомиться')"
                class="modal__attention__btn modal__attention__btn--green"
                @click="updateTask('done', 'Завершить')"
              >
                Завершить
              </button>
              <button
                v-if="selectedRow.path_dot.includes('результат') && selectedRow.result !== 'Согласовано'"
                class="modal__attention__btn modal__attention__btn--orange"
                @click="updateTask('return', 'Повторить согласование')"
              >
                Повторить согласование
              </button>
              <button
                class="modal__attention__btn"
                @click="showModal = false"
              >
                Закрыть
              </button>
            </div>
          </mq-layout>
          <mq-layout :mq="['sm', 'xsm']" class="modal__attention__btns modal__attention__btns--mobile">
            <div class="modal__attention__btns">
              <button
                v-if="selectedRow.path_dot==='Исполнить'"
                class="modal__attention__btn modal__attention__btn--orange"
                @click="updateTask('done', 'Исполнено')"
              >
                Исполнено
              </button>

<!--              <button-->
<!--                v-if="selectedRow.path_dot==='Утвердить'"-->
<!--                class="modal__attention__btn modal__attention__btn&#45;&#45;green"-->
<!--                @click="makeSign"-->
<!--              >-->
<!--                Подписать-->
<!--              </button>-->
<!--              <button-->
<!--                v-if="selectedRow.path_dot==='Утвердить'"-->
<!--                class="modal__attention__btn modal__attention__btn&#45;&#45;orange"-->
<!--                @click="updateTask('reject')"-->
<!--              >-->
<!--                Отклонить-->
<!--              </button>-->

              <button
                v-if="selectedRow.path_dot==='Согласовать'"
                :disabled='noComment'
                class="modal__attention__btn modal__attention__btn--green"
                @click="updateTask('approve', 'Согласовано')"
              >
                Согласовано
              </button>
              <button
                v-if="selectedRow.path_dot==='Согласовать'"
                :disabled='noComment'
                class="modal__attention__btn modal__attention__btn--orange"
                @click="updateTask('reject', 'Не согласовано')"
              >
                Не согласовано
              </button>
              <button
                v-if="selectedRow.path_dot==='Проверить исполнение'"
                :disabled='noComment'
                class="modal__attention__btn modal__attention__btn--green"
                @click="updateTask('done', 'Проверено')"
              >
                Проверено
              </button>
              <button
                v-if="selectedRow.path_dot==='Проверить исполнение'"
                :disabled='noComment'
                class="modal__attention__btn modal__attention__btn--orange"
                @click="updateTask('revision', 'Вернуть на доработку')"
              >
                Вернуть на доработку
              </button>
              <button
                v-if="selectedRow.path_dot.includes('Ознакомиться')"
                class="modal__attention__btn modal__attention__btn--green"
                @click="updateTask('done', 'Завершить')"
              >
                Завершить
              </button>
              <button
                v-if="selectedRow.path_dot.includes('результат') && selectedRow.result !== 'Согласовано'"
                class="modal__attention__btn modal__attention__btn--orange"
                @click="updateTask('return', 'Повторить согласование')"
              >
                Повторить согласование
              </button>
              <button
                class="modal__attention__btn"
                @click="showModal = false"
              >
                Закрыть
              </button>
            </div>
          </mq-layout>
        </div>
      </div>
    </div>
    <!--  Список задач  -->
    <ApolloQuery
      :deep="true"
      :query="require('@/graphql/queries/TasksDo.gql')"
      ref="queryComponentRef"
    >
      <template slot-scope="{ result: { error, data }, isLoading }">
        <div class="messages apollo" v-if="isLoading">
          <div class="messages__status">Загрузка...</div>
        </div>
        <div class="messages apollo" v-else-if="error">
          <div class="messages__status error">Ошибка загрузки данных. Обратитесь в тех. поддержку</div>
        </div>
        <div v-else-if="data">
          <div class="tbl">
            <!--    Задачи свайпом    -->
            <mq-layout :mq="['sm', 'xsm', 'md', 'lg']" v-if="$store.state.data.tasks.isSwipeTasks">
              <tasks-do-cards :visibleCards="data.allDoTasks" :showCardStack="$store.state.data.tasks.isSwipeTasks"/>
            </mq-layout>
            <!--    Задачи списком     -->
            <mq-layout :mq="[ 'lg', 'xlg', 'xl' ]">
              <vue-good-table
                v-if="data && data.allDoTasks"
                :columns="columns"
                :rows="data.allDoTasks"
                @on-row-click="onRowClick"
                compactMode
                :pagination-options="{
                  enabled: true,
                  perPage: 15,
                  nextLabel: '',
                  prevLabel: '',
                  rowsPerPageLabel: 'Вывести',
                  ofLabel: 'из',
                  pageLabel: 'страниц',
                  allLabel: 'Все',
                }"
                :sort-options="{
                  enabled: true,
                  initialSortBy: { field: 'date', type: 'desc' },
                }"
              >
                <div slot="emptystate">Задач нет</div>
                <div slot="table-actions" class="tbl__type">
                  <a
                    :class="{ active: $store.state.data.tasks.view === 'tableDo'}"
                    @click.prevent="$store.state.data.tasks.view = 'tableDo'"
                    href="#"
                  >
                    <TypeCone/>
                  </a>
                  <a
                    :class="{ active: $store.state.data.tasks.view === 'table'}"
                    @click.prevent="$store.state.data.tasks.view = 'table'"
                    href="#"
                  >
                    <TypeTable/>
                  </a>
                  <mq-layout :mq="[ 'lg', 'xlg', 'xl' ]">
                    <a
                      :class="{ active: $store.state.data.tasks.view === 'kanban'}"
                      @click.prevent="$store.state.data.tasks.view = 'kanban'"
                      href="#"
                    >
                      <TypeKanban/>
                    </a>
                  </mq-layout>
                </div>
                <template #table-row="slotProps">
                  <span v-if="slotProps.column.field === 'date'" :id="slotProps.row.id">
                    {{ getDateTime(slotProps.row[slotProps.column.field]) }}
                  </span>
                  <span v-else :id="slotProps.row.id">
                    {{ slotProps.row[slotProps.column.field] }}
                  </span>
                </template>
              </vue-good-table>
            </mq-layout>
            <mq-layout :mq="[ 'md', 'xsm', 'sm', 'xs' ]" class="tbl__container tbl__mobile">
              <div class="tbl__settings tasks-do">
                <div class="tbl__type">
                  <a :class="{ active: $store.state.data.tasks.view === 'tableDo'}" @click.prevent="$store.state.data.tasks.view = 'tableDo'" href="#">
                    <TypeCone/>
                  </a>
                  <a :class="{ active: $store.state.data.tasks.view === 'table'}" @click.prevent="$store.state.data.tasks.view = 'table'" href="#">
                    <TypeTable/>
                  </a>
                </div>
              </div>
              <table>
                <tbody v-if="data && data.allDoTasks && data.allDoTasks.length">
                <tr :key="index" v-for="(task, index) in data.allDoTasks">
                  <td>
                    <div
                      @click="onRowClick({ row: task })"
                      class="tbl__content__container tbl__task"
                      :id="task.id"
                    >
                        <div class="tbl__content">
                        <div class="tbl__task__line">
                          <div class="tbl__task__part">
                            <TypeCone />
                          </div>

                          <!--     Приоритет     -->
                          <div
                            class="tbl__task__part"
                            v-if="task.importance"
                          >
                            Важность:
                            <div
                              class="tag"
                              :class="getImportanceClass(task.importance)"
                            >
                              {{ task.importance }}
                            </div>
                          </div>
                        </div>
                        <!--      Компания     -->
                        <div
                          v-if="task.element && task.element.company_name"
                          class="tbl__task__part"
                        >
                          <!--                        <ContactIco/>-->
                          <span>{{ task.element.company_name }}</span>
                        </div>

                          <!--      Дата       -->
                          <div class="tbl__task__part">
                            <ClockCircle/>
                            <span>{{ getDateTime(task.date) }}</span>
                          </div>

                          <div
                            class="tbl__task__part"
                            v-if="task.subject"
                            style="max-width: 80%;"
                          >
                            <Documentation />
                            <span>{{ task.subject }}</span>
                          </div>

                          <!--      Текст задачи     -->
                          <div class="tbl__task__text" v-if="task.name">
                            {{ task.name }}
                          </div>

                        <div class="tbl__task__line">
                          <!--     Статус     -->
                          <div
                            :class="task.result ? 'tag tag--blue' : ''"
                          >
                            {{ task.result ? task.result.replace(/([a-zа-яё])([A-ZА-ЯЁ])/g, '$1 $2') : '' }}
                          </div>
                        </div>
                        </div>
                    </div>
                  </td>
                </tr>
                </tbody>
                <tbody v-else>
                <tr>
                  <td colspan="1"><p style="text-align: center; font-weight: 600">Нет результатов</p></td>
                </tr>
                </tbody>
              </table>
            </mq-layout>
          </div>
        </div>
      </template>
    </ApolloQuery>
    <!--  Задачи Галимов Марсель Ринатович  -->
    <div v-if="$store.state.me._id === '5ebbd7e19f7bd050e01dbf3f'" style="margin-top: 20px">
      <h3 style="text-align: center">
        Задачи Галимов Марсель Ринатович
      </h3>
      <ApolloQuery :query="require('@/graphql/queries/TasksDoEmployee.gql')">
        <template slot-scope="{ result: { error, data }, isLoading }">
          <div class="messages apollo" v-if="isLoading">
            <div class="messages__status">Загрузка...</div>
          </div>
          <div class="messages apollo" v-else-if="error">
            <div class="messages__status error">Ошибка загрузки данных. Обратитесь в тех. поддержку</div>
          </div>
          <div v-else-if="data">
            <vue-good-table
              :columns="columns"
              :rows="data.allEmployeeDoTasks"
              @on-row-click="onRowClick"
              compactMode
              :pagination-options="{
                enabled: true,
                perPage: 15,
                nextLabel: '',
                prevLabel: '',
                rowsPerPageLabel: 'Вывести',
                ofLabel: 'из',
                pageLabel: 'страниц',
                allLabel: 'Все',
              }"
              :sort-options="{
                enabled: true,
                initialSortBy: { field: 'date', type: 'desc' },
              }"
            >
              <div slot="emptystate">Задач нет</div>
            </vue-good-table>
          </div>
        </template>
      </ApolloQuery>
    </div>
  </div>
</template>

<script>
import TypeTable from '@/components/svg/TypeTable'
import TypeCone from '@/components/svg/TypeCone'
import TypeKanban from '@/components/svg/TypeKanban'
import VISAS from '@/graphql/queries/DocVisas.gql'
import GraphQLHelper from '@/helpers/GraphQLHelper'
import MinusIco from '@/components/svg/minus'
import gql from 'graphql-tag'
import axios from 'axios'
import moment from 'moment'
import CardsComponent from '@/components/ui/SwipeCards/CardsComponent'
import ClockCircle from '@/components/svg/ClockCircle.vue'
import Documentation from '@/components/svg/documentation.vue'
import Close from '@/components/svg/close.vue'
import { markRowToChange } from '@/helpers/utils'
const BASE_URL = process.env.VUE_APP_HTTP
const _graphQlHelper = new GraphQLHelper()

export default {
  name: 'TasksDo',
  components: {
    Close,
    Documentation,
    TypeKanban,
    TypeTable,
    TypeCone,
    MinusIco,
    TasksDoCards: CardsComponent,
    ClockCircle
  },
  data () {
    return {
      BASE_URL,
      message: '',
      subtitleExpanded: false,
      showModal: false,
      selectedRow: {},
      openHistory: false,
      openDocuments: false,
      history: [],
      columnsAgreement: [
        {
          label: 'Согласующее лицо',
          field: 'autor'
        },
        {
          label: 'Результат',
          field: 'result'
        },
        {
          label: 'Комментарий',
          field: 'comment'
        }
      ],
      columns: [
        {
          label: 'Дата',
          field: 'date',
          type: 'date',
          dateInputFormat: `yyyy-MM-dd'T'HH:mm:ss`, // expects 2018-03-16
          dateOutputFormat: 'dd.MM.yyyy HH:mm'
        },
        {
          label: 'Имя',
          field: 'fullname'
        },
        {
          label: 'Автор',
          field: 'autor'
        },
        {
          label: 'Комментарий',
          field: 'comment'
        }
      ],
      docs: [],
      content: ''
    }
  },
  computed: {
    noComment () {
      return !this.message
    }
  },
  methods: {
    async downloadFile (id) {
      await axios.get(`${BASE_URL}/file?id=${id}`)
    },
    async getDocs (id) {
      const docs = await axios.get(`${BASE_URL}/doc?uid=${id}`)
      return docs.data
    },
    async getContext (id) {
      const content = await axios.get(`${BASE_URL}/doc/data?id=${id}`)
      return content.data.content
    },
    async onRowClick (params) {
      this.selectedRow = params.row
      this.docs = await this.getDocs(params.row.doc)
      this.content = await this.getContext(params.row.doc)
      this.history = await this.getVisas(params.row.doc)
      this.showModal = true
    },

    getVisas (doc) {
      let history = []
      this.$apollo
        .mutate({
          mutation: VISAS,
          variables: {
            doc
          },
          update: (_, { data }) => {
            if (data && data.docVisas.length > 0) {
              this.history = [...data.docVisas]
            }
          }
        })
        .catch((error) => {
          _graphQlHelper.graphQLErrorMessages(error).forEach((item) => {
            this.$notify({
              group: 'lsg-notify',
              text: item
            })
          })
        })
      return history
    },

    // makeSign () {
    //   this.showModal = false
    //   this.updateTask('sign') // Подписать (утвердить)
    // },

    updateTask (type, actionName, registryId) {
      this.showModal = false

      markRowToChange(this.$refs.queryComponentRef.$el, this.selectedRow.id)

      if (actionName) {
        this.$notify({
          group: 'lsg-notify',
          text: `Применение действия "${actionName}" по задаче: ${this.selectedRow.name}`,
          duration: -1
        })
      }

      const updateTaskMutation = this.$apollo.mutate({
        mutation: gql`mutation updateDOTask($ids: [String!], $type: String, $comment: String, $registry_id: String) {
          updateDOTask (ids: $ids, type: $type, comment: $comment, registry_id: $registry_id)
        }`,
        variables: {
          type,
          comment: this.message,
          ids: [this.selectedRow.id],
          registry_id: registryId
        }
      })

      updateTaskMutation.then(() => {
        this.$refs.queryComponentRef.getApolloQuery().refetch()
          .then(() => {
            setTimeout(() => {
              this.$notify({
                group: 'lsg-notify',
                clean: true
              })

              this.$notify({
                group: 'lsg-notify',
                text: `Успешно - "${actionName}" по задаче: ${this.selectedRow.name}`
              })
            }, 1000)
          })
          .catch(error => {
            this.$notify({
              group: 'lsg-notify',
              clean: true
            })

            _graphQlHelper.graphQLErrorMessages(error).forEach(item => {
              this.$notify({
                group: 'lsg-notify',
                text: `Ошибка применения действия "${actionName}" по задаче: ${this.selectedRow.name}. (${item})`
              })
            })
            markRowToChange(this.$refs.queryComponentRef.$el, this.selectedRow.id, true)
          })
      })
        .catch(error => {
          this.$notify({
            group: 'lsg-notify',
            clean: true
          })

          _graphQlHelper.graphQLErrorMessages(error).forEach(item => {
            this.$notify({
              group: 'lsg-notify',
              text: `Ошибка применения действия "${actionName}" по задаче: ${this.selectedRow.name}. (${item})`
            })
          })
          markRowToChange(this.$refs.queryComponentRef.$el, this.selectedRow.id, true)
        })
    },

    getDateTime (date) {
      return moment(date).format('MM.DD.YYYY HH:mm')
    },
    getImportanceClass (status) {
      switch (status) {
        case 'Низкая':
          return 'tag--green'
        case 'Обычная':
          return 'tag--yellow'
        case 'Высокая':
          return 'tag--red'
        default:
          return 'tag--yellow'
      }
    }
  },

  watch: {
    '$data.showModal' () {
      if (!this.showModal) {
        this.$data.message = ''
        this.$data.openHistory = false
        this.$data.openDocuments = false
      }
    }
  }
}
</script>

<style lang="stylus">
  .tag--task {
    display: inline-block
  }
  .footer__navigation__page-info {
    margin: auto 16px !important;
  }
  .modal__body--task-do {
    max-width: 700px;
    margin-bottom: 70px
  }
  @media (max-width: 768px) {
    .modal__body--task-do {
      max-width: 90%;
      margin-bottom: 70px
    }
  }
  .modal__attention__files
    cursor pointer
    color #FF8000
    display flex
    gap 8px
    svg
      flex-shrink 0
      path
        stroke $orange

  .modal__attention__table {
    margin-bottom: 15px;
  }
  .modal__attention__files:hover {
    text-shadow: 1px 1px 1px #FF8000
  }
  .modal__attention__container {
    overflow-y: scroll;
    white-space: pre-wrap;
    /* max-height: 600px; */
    width: 100%
  }
  .open {
    height: auto
  }
  button:disabled,
  button[disabled]{
    border: 1px solid #999999;
    background-color: #cccccc;
    color: #666666;
    pointer-events: none;
  }

  .messages
    &.apollo
      margin-top 30px
      padding 0 20px

  .tbl
    margin-top 30px
    &__container
      display block !important
    &__settings
      padding-top 20px
      padding-bottom 20px
      padding-right 20px
      flex-direction row !important
      justify-content flex-end
      @media (max-width 576px)
        border-bottom 1px solid $pinky
        padding-right 0
      &.tasks-do
        padding 20px !important
        border-bottom 1px solid $pinky !important
  .modal
    &__close
      cursor pointer
      width 20px
      height 20px
      align-self flex-end
      &:hover
        opacity 0.7
    &__comment
      width 100%
      textarea
        width 100%
        border-color $dark
        transition border-color 0.3s ease-in
        &:focus
          box-shadow none
          border 2px solid $orange
      @media (max-width 576px)
        width 100%
        text-align start
    &__attention
      gap 30px
      &__header
        display flex
        justify-content space-between
        gap 20px
        position sticky
        top 0
        background-color $white
        padding 15px
        margin-left -15px
        margin-right -15px
        margin-top -15px
        z-index 1
        border-radius 10px
        flex-direction column
        align-items flex-start
      label
        margin-bottom 10px
        display flex
        justify-content space-between
        align-items center
        color $c848A8F
      &__title
        margin-bottom 0
      &__description
        p
          border 1px solid $darkgray
          padding 10px
          border-radius 10px
          color $dark
      &__table
        border-radius 10px
        width 100%
        .vgt-wrap
          padding 0 1px
          border 1px solid $darkgray
          border-radius: 10px
          overflow hidden
          .vgt-table tr td
              border-top none
              &:not(:first-child)
                border-top 1px solid $darkgray !important

        @media (max-width 576px)
          .vgt-fixed-header
            display none
          .vgt-responsive
            .vgt-table
              td
                padding 10px
              tr:not(:last-child)
                margin-bottom 0
                border-bottom 1px solid $orange
          .vgt-compact td
            color $dark
            display flex
            gap 10px
            width 100%
            justify-content space-between
            div
              max-width 60%
            &::before
              float unset
              max-width calc(40% - 5px)
              color $c848A8F
              padding-left 0
      &__block
        max-width 100%
        ul
          padding 0
          li
            margin-bottom 8px
            a
              span
                white-space wrap
                overflow hidden
                text-overflow ellipsis
                max-width 100%
                color $orange

</style>
